import * as angular from "angular";
import {TeamsService} from "./teams.service";
import {TeamModel} from "../models/team.model";

export class TeamsDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private teamsService: TeamsService) {
  }

  createTeam(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/team-form-dialog.html').default,
      controller: function ($scope) {

        $scope.team = {};
        $scope.header = 'Create Team';

        $scope.cancel = self.$mdDialog.cancel;


        // ******************************
        // External methods
        // ******************************

        $scope.onAgentsSelect = (ids) => {
          $scope.teamAgentIds = ids;
        }

        $scope.onChangeAdmins = (admins, adminIds) => {
          $scope.team.memberIds = adminIds;
        }

        $scope.onAddContact = () => {
          if (!$scope.team.contactPeople) {
            $scope.team.contactPeople = []
          }
          $scope.team.contactPeople.push({
            allowReceiveSmsNotifications: true,
            allowReceiveEmailNotifications: true
          });
        }

        $scope.onRemoveContact = (index) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy.splice(index, 1);
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.onContactPhoneChange = ($index, phone) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy[$index].phoneNumber = phone;
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.onToggleContactReceiveSmsNotifications = ($index) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy[$index].allowReceiveSmsNotifications = !contactsCopy[$index].allowReceiveSmsNotifications;
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.onToggleContactReceiveEmailNotifications = ($index) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy[$index].allowReceiveEmailNotifications = !contactsCopy[$index].allowReceiveEmailNotifications;
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({team: $scope.team, teamAgentIds: $scope.teamAgentIds});
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  editTeam(team, teamAgentIds: string[], event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/team-form-dialog.html').default,
      controller: function ($scope) {

        $scope.team = team;
        $scope.teamAgentIds = teamAgentIds;
        $scope.header = 'Edit Team';
        $scope.isEdit = true;

        $scope.cancel = self.$mdDialog.cancel;


        // ******************************
        // External methods
        // ******************************

        $scope.onChangeAdmins = (admins, adminIds) => {
          $scope.team.memberIds = adminIds;
        }

        $scope.onAgentsSelect = (ids) => {
          $scope.teamAgentIds = ids;
        }

        $scope.onAddContact = () => {
          if (!$scope.team.contactPeople) {
            $scope.team.contactPeople = []
          }
          $scope.team.contactPeople.push({
            allowReceiveSmsNotifications: true,
            allowReceiveEmailNotifications: true
          });
        }

        $scope.onRemoveContact = (index) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy.splice(index, 1);
          $scope.team.contactPeople = contactsCopy;
        }


        $scope.onContactPhoneChange = ($index, phone) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy[$index].phoneNumber = phone;
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.onToggleContactReceiveSmsNotifications = ($index) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy[$index].allowReceiveSmsNotifications = !contactsCopy[$index].allowReceiveSmsNotifications;
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.onToggleContactReceiveEmailNotifications = ($index) => {
          const contactsCopy = angular.copy($scope.team.contactPeople);
          contactsCopy[$index].allowReceiveEmailNotifications = !contactsCopy[$index].allowReceiveEmailNotifications;
          $scope.team.contactPeople = contactsCopy;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({team: $scope.team, teamAgentIds: $scope.teamAgentIds});
            }
          }
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }


  addAdminToTeam(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/select-team-dialog.html').default,
      controller: function ($scope) {

        $scope.selectedTeam = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSelectTeam = (team: TeamModel) => {
          $scope.selectedTeam = team;
        }

        // ******************************
        // External methods
        // ******************************

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selectedTeam);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }


}

angular
  .module('bringoz.admin.teams')
  .service('teamsDialogService', TeamsDialogService);
